import { api } from "./api"; 

export const playerService = {
  getPlayerStatus: async (playerId: string) => {
    const res = await api.get(`player/${playerId}/status`);
    return res.data;
  },

  setPlayerExtra: async (playerId: string, extra: Record<string, any>) => {
    const payload = { extra, _id: playerId };
    const res = await api.put(`player/${playerId}`, payload);
    return res.data;
  },

  getPoints: async() => {
    const {data} = await api.get('/point');
    return data;
  },

  getSkills: async (playerId: string) => {
    const {data} = await api.get(`/achievement?player=${playerId}&item=skill`);
    return data;
  },
  getMotivations: async (playerId: string) => {
    const {data} = await api.get(`/achievement?player=${playerId}&item=motivation`);
    return data;
  },
  getKnowledges: async (playerId: string) => {
    const {data} = await api.get(`/achievement?player=${playerId}&item=knowledge`);
    return data;
  }
};